<template>
  <div>
    <label class="tw-flex tw-items-start tw-text-sm">
      <input
        class="tw-text-gray-600 tw-focus:border-gray-600"
        type="radio"
        autocomplete="off"
        :disabled="item.Disabled"
        :checked="item.Selected"
        :value="item.Value"
        :name="radioGroupName"
        @change="
          $emit('removeTag'),
            $emit('filterChange', {
              Item: item,
              Group: group.Group,
              Type: group.Type,
              index: index,
              Type: 'Radio',
            })
        "
      />
      <span
        class="tw-ml-2 tw-pr-2"
        :class="item.Selected ? 'tw-font-bold' : ''"
        >{{ item.Text }}</span
      >
    </label>
  </div>
</template>

<script>
export default {
  name: "Radio",
  props: {
    radioGroupName: String,
    item: {
      Disabled: Boolean,
      Selected: Boolean,
      Value: String,
      Name: String,
    },
    group: Object,
    index: Number,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input[type="radio"]:disabled {
  opacity: 0.3;
}
</style>
